import React from 'react';
import { Container, Avatar, Typography, Box, Divider, Paper } from '@mui/material';

function BioPage() {
  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', backgroundColor: '#f5f5f5', padding: '50px 20px', borderRadius: '10px' }}>
      {/* Profile Picture */}
      <Avatar
        alt="Mouhamed Nazif"
        src="/profile.jpg"
        sx={{ width: 150, height: 150, margin: '0 auto 20px', border: '5px solid #fff' }}
      />
      
      {/* Name and Title */}
      <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: '10px' }}>
      MOUTAWAKILOU EL-HADJI ALASSANE Mouhamed Nazif 
      </Typography>
      <Typography variant="h6" color="textSecondary" sx={{ marginBottom: '30px' }}>
      Qualiticien | Microbiologiste | Toxicologue
      </Typography>

      {/* Professional Summary */}
      <Paper sx={{ padding: '20px', marginBottom: '30px', boxShadow: 3, backgroundColor: '#fff' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
          Parcours Professionnel 
        </Typography>
        <Typography sx={{ marginBottom: '40px', lineHeight: 2.0, textAlign: 'justify' }}>
          Dr. MOUTAWAKILOU Mouhamed Nazif est un qualiticien béninois, microbiologiste et toxicologue. Il a obtenu sa Licenec en Génie des procédés d'analyses agro-alimentaire et biotechnologiques puis le Master en Génie des Procédés d'expertises d'analyses et biotechnologie, Option : Génies Pharmaceutique, chimique et toxicologie avant de soutenir sa thèse de Doctorat à l'Université d'Abomey Calavi en Microbiologie et toxicologie.
        </Typography>

        <Typography sx={{ lineHeight: 2.0, textAlign: 'justify' }}>
          Il a été successivement:
        </Typography>

        <Box sx={{marginBottom:"40px", paddingLeft: '20px', marginTop: '10px' }}>
          <Typography sx={{ textAlign: 'justify', marginBottom: '10px' }}>
              • Technicien Supérieur de laboratoire physico-chimiques,
          </Typography>
          <Typography sx={{ textAlign: 'justify', marginBottom: '10px' }}>
              • Opérateur du High Performance Liquid Chromatography (HPLC) jusqu'en 2014 à la Direction de la Promotion de la Qualité et du Conditionnement (DPQC) du Ministère de l'Agriculture, de l'Élevage et de la Pêche (MAEP).
          </Typography>
          <Typography sx={{ textAlign: 'justify', marginBottom: '10px' }}>
              • Responsable du Laboratoire Unité de Surveillance des Contaminants Agricoles,
          </Typography>
          <Typography sx={{ textAlign: 'justify', marginBottom: '10px' }}>
              • Chargé des contrôles sanitaires et phytosanitaires à l'aéroport international de Cotonou,
          </Typography>
            <Typography sx={{ textAlign: 'justify', marginBottom: '10px' }}>
              • Chargé de l'évaluation des risques sanitaires jusqu'en 2019.
          </Typography>
        </Box>

        <Typography sx={{ marginBottom: '40px', lineHeight: 2.0, textAlign: 'justify' }}>
        Il est le fondateur du laboratoire privé d'essai et de Recherche en agro-alimentaire (Agro Sciences Laboratory) en 2020.
        </Typography>
        
        <Typography sx={{ marginBottom: '40px', lineHeight: 2.0, textAlign: 'justify' }}>
        Nommé Directeur Général de l'Agence nationale de Normalisation, de la Métrologie et du Contrôle Qualité par décret gouvernemental en Conseil des Ministres du 18 décembre 2024, il prend service le 26 décembre de ce même mois et gère de mains de maître cette institution combien névralgique de la vie des populations.
        </Typography>
      </Paper>

      {/* Education */}
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
        Formation
      </Typography>
      <Box sx={{ marginBottom: '50px', textAlign: 'left' }}>
      <Typography sx={{ marginBottom: '20px' }}>
          <strong>Doctorat :</strong> Microbiologie et toxicologie 
          <Box sx={{ color: '#888', fontSize: '14px'}}>
          Université d'Abomey Calavi, 2024
          </Box>
        </Typography>

        <Typography sx={{ marginBottom: '20px' }}>
          <strong>Master :</strong> Génies Pharmaceutique, chimique et toxicologie
          <Box sx={{ color: '#888', fontSize: '14px'}}>
          IRGIB AFRICA, 2011
          </Box>
        </Typography>  
        
        <Typography sx={{ marginBottom: '20px' }}>
          <strong>Licence :</strong> Génie des procédés d'analyses agro-alimentaire et biotechnologiques
          <Box sx={{ color: '#888', fontSize: '14px'}}>
          IRGIB AFRICA, 2009
          </Box>
        </Typography>              
      </Box>

      {/* Contact Information */}
      <Divider sx={{ marginBottom: '30px' }} />
      <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '15px' }}>
        Contact Information
      </Typography>
      <Typography>Email: <a href="mailto:mouhamed1moutawakilou@gmail.com">mouhamed1moutawakilou@gmail.com</a></Typography>
    </Container>
  );
}

export default BioPage;
